// src/chains/taraxa.js - Keep using direct contract calls for now
import { createChainConfig } from './chainConfig';

export const taraxaConfig = createChainConfig({
  key: 'taraxa', 
  chainId: 841,
  name: 'Taraxa Mainnet',
  rpcUrl: 'https://rpc.mainnet.taraxa.io',
  explorerUrl: 'https://tara.to',
  
  // Native token information
  nativeTokenSymbol: 'TARA',
  nativeTokenName: 'Taraxa',
  nativeTokenIcon: 'https://i.imgur.com/TeZz82v.png',
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0x5d0Fa4C5668E5809c83c95A7CeF3a9dd7C68d4fE', // WTARA
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=taraxa&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'taraxa',
  geckoTerminalId: 'taraxa',
  tokenListUrl: 'https://api.fomo.biz/tokens/dex',
  
  // BitDogSwap aggregator address - continue using direct contract calls
  aggregatorAddress: '0x9A8097dA2b5A8967d64b3694286428263745fFB5',
  
  // Transaction support
  supportsEIP1559: false,

  txHistoryApi: 'https://api.routescan.io/v2/network/mainnet/evm/841/address/{address}/transactions'
});